import { apiService } from "api/apiService";
import type {
  StudentPortfolioAssignmentShallowResource,
  FilterResource,
} from "api/generated";
import { teacherStudentAssignmentShallowFromDto } from "portfolio/api/mappers";
import { mapFilters } from "shared/mappers";
import type { TeacherStudentAssignmentShallow } from "portfolio/types";
import type { PaginatedResponse, PaginatedResult } from "api/types";
import type { Filter } from "shared/types";
import { mapPaginatedResponse } from "api/mappers/pagination.mapper";

export const fetchStudentTasks = async (
  studentId: number,
  params: Record<string, string> = {},
): Promise<PaginatedResult<TeacherStudentAssignmentShallow>> => {
  const { data } = await apiService.get<
    PaginatedResponse<StudentPortfolioAssignmentShallowResource>
  >(`api/portfolio/students/${studentId}/tasks`, { params });

  return mapPaginatedResponse(data, teacherStudentAssignmentShallowFromDto);
};

export const fetchStudentTasksFilters = async (
  studentId: number,
): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/portfolio/students/${studentId}/tasks/filters`,
  );

  return mapFilters(filters);
};
